<template>
  <div class="w-full flex flex-col items-center gap-3 mb-3">
    <button
      @click="sendAll"
      class="boton-front bg-green-600 hover:bg-green-700 text-white font-bold py-2 px-4 rounded disabled:opacity-60"
      :disabled="loading"
    >
      <span v-if="!loading">{{ uiT('bulkEmail.button') }}</span>
      <span v-else>{{ uiT('bulkEmail.sending') }}</span>
    </button>

    <!-- Estado / resultado (opcional) -->
    <div v-if="loading" class="w-full max-w-2xl">
      <p class="text-sm text-gray-600">{{ uiT('bulkEmail.processing') }}</p>
      <div class="w-full bg-gray-200 rounded-full h-2 mt-2 overflow-hidden">
        <div class="bg-green-600 h-2 animate-pulse" style="width: 80%"></div>
      </div>
    </div>

    <div v-if="result" class="w-full max-w-2xl border rounded-lg p-3">
      <p class="font-semibold">
        {{ uiT('bulkEmail.result') }}
        <span :class="result.status === 'ok' ? 'text-green-700' : 'text-red-700'">{{ result.status }}</span>
      </p>
      <p class="text-sm text-gray-600">{{ uiT('bulkEmail.message') }} {{ result.mensaje }}</p>
      <p class="text-sm text-gray-600">{{ uiT('bulkEmail.processes') }} {{ result.procesos }}</p>

      <details class="mt-2">
        <summary class="cursor-pointer text-sm text-gray-700">{{ uiT('bulkEmail.details') }}</summary>
        <div class="mt-2 space-y-3 max-h-64 overflow-auto">
          <div
            v-for="(item, idx) in result.resumen"
            :key="idx"
            class="border rounded p-2"
          >
            <p class="font-medium">
              {{ uiT('bulkEmail.group') }} <span class="text-gray-700">{{ item.grupo ?? uiT('bulkEmail.unnamed') }}</span>
            </p>
            <p class="text-xs">
              {{ uiT('bulkEmail.status') }}
              <span :class="item.status === 'ok' ? 'text-green-700' : 'text-red-700'">{{ item.status }}</span>
              <span v-if="item.error" class="text-red-600"> — {{ item.error }}</span>
            </p>

            <details v-if="item.resultados && item.resultados.length" class="mt-1">
              <summary class="cursor-pointer text-sm text-gray-700">
                {{ uiT('bulkEmail.sentEmails', { count: item.resultados.length }) }}
              </summary>
              <ul class="mt-1 pl-4 list-disc text-sm">
                <li v-for="(r, j) in item.resultados" :key="j">
                  {{ r.nombre }} — {{ r.correo }}:
                  <strong :class="(r.resultado?.status === 'ok') ? 'text-green-700' : 'text-red-700'">
                    {{ r.resultado?.status }}
                  </strong>
                  <span v-if="r.resultado?.mensaje"> ({{ r.resultado.mensaje }})</span>
                </li>
              </ul>
            </details>
          </div>
        </div>
      </details>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { useToast } from "vue-toastification";
import { userManagementI18nMixin } from "@/views/usuarios/i18n/userManagementI18n.js";

export default {
  name: 'EnviarMasivoEventoSimple',
  mixins: [userManagementI18nMixin],
  props: {
    eventoToken: {
      type: String,
      required: true
    }
  },
  setup() {
    const toast = useToast();
    return { toast };
  },
  data() {
    return {
      loading: false,
      result: null
    };
  },
  methods: {
    async sendAll() {
      if (!this.eventoToken) {
        this.toast.warning(this.uiT('bulkEmail.missingToken'));
        return;
      }
      this.loading = true;
      this.result = null;

      try {
        // IMPORTANTE: sin 'category' -> el backend debe asumir "todos"
        const { data } = await axios.post('/api/preinvitacion/masiva', {
          token_evento: this.eventoToken
          // Si todavía te exige category, temporalmente envía algo como:
          // category: 'ALL'
        });

        this.result = data;
        if (data.status === 'ok') {
          this.toast.success(this.uiT('bulkEmail.complete'));
          this.$emit('massSent', data);
        } else {
          this.toast.error(data.error || this.uiT('bulkEmail.error'));
        }
      } catch (err) {
        console.error(err);
        this.toast.error(this.uiT('bulkEmail.requestError'));
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>

<style scoped>
.boton-front { width: 100%; max-width: 420px; }
</style>
